<template>
    <jet-action-section>
        <template #title> Theme </template>

        <template #description> Choose how app looks to you. Select a single theme, or sync with your system and automatically switch between day and night themes.</template>

        <template #content>
            <h3 class="text-gray-900 text-lg font-medium">Theme Mode</h3>

            <div class="mt-3">
                <fieldset>
                    <legend class="sr-only">Privacy setting</legend>
                    <div class="bg-white rounded-md -space-y-px">
                        <label class="relative flex p-4 border-0 rounded-tl-md rounded-tr-md focus:outline-none cursor-pointer">
                            <input type="radio" v-model="form.theme" value="sync" class="mt-0.5 w-4 h-4 text-indigo-600 border-gray-300 cursor-pointer focus:ring-indigo-500" aria-labelledby="theme-setting-0-label" aria-describedby="theme-setting-0-description" />
                            <div class="flex flex-col ml-3">
                                <span id="theme-setting-0-label" :class="[theme === 'sync' ? 'text-indigo-900' : 'text-gray-900']" class="block text-sm font-medium"> Sync with system </span>
                                <span id="theme-setting-0-description" :class="[theme === 'sync' ? 'text-indigo-700' : 'text-gray-500']" class="block text-sm"> App theme will match your system active settings </span>
                            </div>
                        </label>

                        <label class="relative flex p-4 border-0 focus:outline-none cursor-pointer">
                            <input type="radio" v-model="form.theme" value="light" class="mt-0.5 w-4 h-4 text-indigo-600 border-gray-300 cursor-pointer focus:ring-indigo-500" aria-labelledby="theme-setting-2-label" aria-describedby="theme-setting-2-description" />
                            <div class="flex flex-col ml-3">
                                <span id="theme-setting-2-label" :class="[theme === 'light' ? 'text-indigo-900' : 'text-gray-900']" class="block text-sm font-medium"> Light theme </span>
                                <span id="theme-setting-2-description" :class="[theme === 'light' ? 'text-indigo-700' : 'text-gray-500']" class="block text-sm"> App theme will be set to light </span>
                            </div>
                        </label>

                        <label class="relative flex p-4 border-0 rounded-bl-md rounded-br-md focus:outline-none cursor-pointer">
                            <input type="radio" v-model="form.theme" value="dark" class="mt-0.5 w-4 h-4 text-indigo-600 border-gray-300 cursor-pointer focus:ring-indigo-500" aria-labelledby="theme-setting-2-label" aria-describedby="theme-setting-2-description" />
                            <div class="flex flex-col ml-3">
                                <span id="theme-setting-3-label" :class="[theme === 'dark' ? 'text-indigo-900' : 'text-gray-900']" class="block text-sm font-medium"> Dark theme </span>
                                <span id="theme-setting-3-description" :class="[theme === 'dark' ? 'text-indigo-700' : 'text-gray-500']" class="block text-sm"> App theme will be set to dark </span>
                            </div>
                        </label>
                    </div>
                </fieldset>
            </div>
        </template>
    </jet-action-section>
</template>

<script>
import JetActionSection from "@/Jetstream/ActionSection"

export default {
    components: {
        JetActionSection,
    },

    props: {
        theme: {
            default: "sync",
        },
    },

    watch: {
        "form.theme": function (val, oldVal) {
            this.updateThemeSettings()
            this.updateCssClass(val, oldVal)
        },
    },

    data() {
        return {
            form: this.$inertia.form({
                _method: "POST",
                theme: this.theme,
            }),
        }
    },

    methods: {
        updateThemeSettings() {
            this.form.put(route("user-theme.update"), {
                errorBag: "updateTheme",
                preserveScroll: true,
            })
        },
        updateCssClass(val, oldVal) {
            document.documentElement.classList.remove(oldVal)
            document.documentElement.classList.remove("light")
            document.documentElement.classList.remove("dark")
            document.documentElement.classList.remove("sync")
            this.$nextTick(() => document.documentElement.classList.add(val))
        },
    },
}
</script>
